// Auth0Config.ts
import {
  AUTH0_DOMAIN,
  AUTH0_SECRET,
  AUTH0_AUDIENCE,
  AUTH_MODE
} from '../app/AppConfig'

import { GetAuth0Org, GetAuth0RedirectUri } from "../components/Utils";


export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  mode: string;
  isActive: boolean;
  orgId: string;
  redirectUri: string;
}

export const getAuth0Config = (authOrgId: string = ""): Auth0Config => {
  const domain = AUTH0_DOMAIN || '';
  const clientId = AUTH0_SECRET || '';
  const audience = AUTH0_AUDIENCE || '';
  const mode = AUTH_MODE || 'disabled';
  const orgId = GetAuth0Org(authOrgId);
  const redirectUri = GetAuth0RedirectUri(authOrgId);

  // Add an automatic activation flag:
  const isActive =
    domain.length > 0 &&
    clientId.length > 0 &&
    mode.toLowerCase() === 'auth0';

  return {
    domain,
    clientId,
    audience,
    mode,
    isActive,
    orgId,
    redirectUri
  };
};
